import React from 'react';
import PropTypes from 'prop-types';
import '../styles.scss';
import ProjectItem from '../project_item_v2';

Project.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    title_2: PropTypes.string,
};

function Project(props) {
    const { data, title, title_2, responsive } = props;

    return (
        <section className="tf-section project_3 additional-class">
            <div className="overlay" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                <img src="/assets/images/backgroup/bg_pagetitle.png" alt="" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title mt-4">
                                {title} <br className="show-destop" />
                                <span style={{ color: '#F19800' }}>{title_2}</span>
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="project-box-style2_wrapper">
                            {
                                data.map(item => (
                                    <ProjectItem key={item.id} item={item} responsive={responsive} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Project;